import React, { useEffect, useState } from "react";
import axios from "axios";
import { parse } from "tldts";
import "../css/Faq.css";
import Navbarlanding from "../landing/Navbarlanding";
import Footerlanding from "../landing/Footerlanding";

const Faq = () => {
  const [company, setCompany] = useState({
    name: "Our Company",
    logo: "",
    favicon: "",
    domain: "",
    subdomain: "",
    email:"",
  });
  const [fetchError, setFetchError] = useState("");
  const [openIndex, setOpenIndex] = useState(null);

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain } = getDomainInfo();
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });
        const data = response.data;

        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
            logo: data.logo || prev.logo,
            favicon: data.favicon || prev.favicon,
            domain: data.domain || prev.domain,
            subdomain: data.subdomain || prev.subdomain,
            email:data.email || prev.email,
          }));

          if (data.favicon) {
            const link =
              document.querySelector("link[rel*='icon']") ||
              document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = `https://payyug.in/${
              data.favicon.startsWith("images/")
                ? data.favicon.slice(7)
                : data.favicon
            }`;
            document.head.appendChild(link);
          }
        } else {
          setFetchError("Company info not found.");
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
        setFetchError("Failed to fetch company info.");
      }
    };

    fetchCompany();
  }, []);

 const supportEmail = company?.email || "support@yourdomain.com";
const contactEmail = company?.email || "contact@yourdomain.com";

  const faqs = [
    {
      q: `What is ${company.name}?`,
      a: (
        <p>
          {company.name} is a digital banking software platform that provides
          technology-based solutions for savings, deposits, virtual accounts,
          and loan application services. We help users access financial services
          through a secure and online system.
        </p>
      ),
    },
    {
      q: `Is ${company.name} a bank?`,
      a: (
        <>
          <p>No.</p>
          <p>
            {company.name} is not a bank or financial institution. It is a
            digital banking software platform that facilitates services in
            partnership with authorized financial institutions and service
            providers.
          </p>
        </>
      ),
    },
    {
      q: `What services are available on ${company.name}?`,
      a: (
        <>
          <p>{company.name} offers access to the following services:</p>
          <ul>
            <li>Savings Account services</li>
            <li>Recurring Deposit (RD) Account</li>
            <li>Fixed Deposit (FD) Account</li>
            <li>Virtual Account solutions</li>
            <li>Group Loan</li>
            <li>Personal Loan</li>
            <li>Instant Loan</li>
            <li>Small Business Loan</li>
          </ul>
          <p>All services are subject to eligibility and approval by respective partners.</p>
        </>
      ),
    },
    {
      q: "Can I apply for services online?",
      a: (
        <p>
          Yes. {company.name} provides a 100% online application process,
          allowing users to apply for accounts and loans digitally with minimal
          documentation.
        </p>
      ),
    },
    {
      q: "What documents are required?",
      a: (
        <>
          <p>Document requirements may vary depending on the service but generally include:</p>
          <ul>
            <li>Valid identity proof</li>
            <li>Address proof</li>
            <li>KYC documents</li>
            <li>Additional documents as required by partners</li>
          </ul>
        </>
      ),
    },
    {
      q: "Does submitting an application guarantee approval?",
      a: (
        <>
          <p>No.</p>
          <p>
            Submitting an application does not guarantee approval. All
            applications are subject to verification, eligibility criteria,
            and approval by financial partners.
          </p>
        </>
      ),
    },
    {
      q: "How long does approval take?",
      a: (
        <>
          <p>Approval timelines depend on:</p>
          <ul>
            <li>Type of service</li>
            <li>Completeness of documents</li>
            <li>Partner institution policies</li>
          </ul>
          <p>{company.name} aims to process requests as quickly as possible.</p>
        </>
      ),
    },
    {
      q: `Is my data safe on ${company.name}?`,
      a: (
        <>
          <p>Yes.</p>
          <p>
            We use secure servers, SSL encryption, and access control measures
            to protect user data. However, no online system can guarantee 100%
            security.
          </p>
        </>
      ),
    },
    {
      q: `Does ${company.name} charge any fees?`,
      a: (
        <>
          <p>
            Some services may involve processing or service charges, which are
            clearly disclosed before proceeding.
          </p>
          <p>There are no hidden charges.</p>
        </>
      ),
    },
    {
      q: "How can I track my application status?",
      a: (
        <>
          <p>You can:</p>
          <ul>
            <li>Log in to your account</li>
            <li>Contact customer support</li>
          </ul>
          <p>📧 {supportEmail}</p>
        </>
      ),
    },
    {
      q: "What should I do if I face login or technical issues?",
      a: (
        <>
          <p>Please contact our support team:</p>
          <p>📧 {supportEmail}</p>
          <p>Provide your registered email or mobile number for faster assistance.</p>
        </>
      ),
    },
    {
      q: `Does ${company.name} ask for OTP or passwords?`,
      a: (
        <>
          <p>No.</p>
          <p>
            {company.name} never asks for OTP, PIN, or passwords. Do not share
            sensitive information with anyone.
          </p>
        </>
      ),
    },
    {
      q: "Can I update or correct my personal information?",
      a: (
        <>
          <p>Yes.</p>
          <p>
            You may request corrections by contacting: 📧 {supportEmail}
          </p>
          <p>Subject to verification and legal requirements.</p>
        </>
      ),
    },
    {
      q: `Is ${company.name} available across India?`,
      a: (
        <p>
          Service availability may vary based on partner institutions and
          regulatory requirements. Please check eligibility during the
          application process.
        </p>
      ),
    },
    {
      q: `How can I contact ${company.name}?`,
      a: (
        <>
          <p>Customer Support: 📧 {supportEmail}</p>
          <p>Official / Business: 📧 {contactEmail}</p>
        </>
      ),
    },
  ];

  return (
    <div className="faq-page">
      <Navbarlanding />

      <div className="faq-wrapper">
        <h1>Frequently Asked Questions (FAQ)</h1>

        {fetchError && <p className="error-text">{fetchError}</p>}

        <div className="faq-list">
          {faqs.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                className="faq-question"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                {item.q}
                 <span>{openIndex === index ? "−" : "+"}</span>
              </button>

              {openIndex === index && (
                <div className="faq-answer">{item.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>

      <Footerlanding />
    </div>
  );
};

export default Faq;
